import { render, staticRenderFns } from "./CalendarList.vue?vue&type=template&id=4987705d&scoped=true&"
import script from "./CalendarList.vue?vue&type=script&lang=js&"
export * from "./CalendarList.vue?vue&type=script&lang=js&"
import style0 from "./CalendarList.vue?vue&type=style&index=0&id=4987705d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4987705d",
  null
  
)

export default component.exports